'use client';

import { WithClassName } from 'src/utils/UtilityTypes';
import TextButton from '../primitives/TextButton/TextButton';

interface ExpandAllButtonProps extends WithClassName {
	areAllItemsExpanded: boolean;
	totalCount: number;
	onExpandAll: () => void;
	onCollapseAll: () => void;
}

function ExpandAllButton({
	areAllItemsExpanded,
	totalCount,
	onExpandAll,
	onCollapseAll,
	className,
}: ExpandAllButtonProps) {
	if (totalCount === 0) return null;

	return (
		<div className="flex w-16 justify-end">
			{areAllItemsExpanded ? (
				<TextButton
					variant="tertiary"
					size="sm"
					className={className}
					onClick={onCollapseAll}
				>
					Collapse All
				</TextButton>
			) : (
				<TextButton
					variant="tertiary"
					size="sm"
					className={className}
					onClick={onExpandAll}
				>
					Expand All
				</TextButton>
			)}
		</div>
	);
}

export default ExpandAllButton;
